import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux'
import * as actions from '../../../store/actions'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {formatFEIN} from '../../../helpers';


// import { history } from '../../../Router'
import { history } from '../../../history'

import UploadFile from '../../UI/UploadFile/UploadFile'

import { 
  Typography,
  Dialog,
  DialogActions,
  DialogTitle, 
  DialogContent,
  DialogContentText, 
  Button,
  TextField,
  Divider,
  Grid,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import useClasses from '../../../helpers/useClasses';

const styles = theme => ({
  button: {
    marginTop: '9px',
    marginRight: '20px',
    '& span': {
      color: '#fff !important'
    },
    paddingTop: '8px',
    paddingBottom: '8px'
  },
  dialog_title: {
    '& h2': {
      fontSize: '20px',
      lineHeight: '30px',
    }
  },
  dialog_text: {
    '& span': {
      fontSize: '16px',
      lineHeight: '20px',
      color: theme.palette.black
    },
    '& p': {
      fontSize: '16px',
      lineHeight: '20px',
      color: theme.palette.black
    }
  },
  dialog_button: {
    '& span': {
      fontSize: '16px',
      lineHeight: '20px'
    }
  },
  input: {
    display: 'none',
  },
  upload_processed_text: {
    fontSize: '20px'
  }
});

const MerchantScrubberDialog = props => {
  const { 
    openDialog,
    onCloseDialog,
    accountId,
    onAddSingleMerchantScrubber,
    page,
    per_page,
    search
  } = props;
  const classes = useClasses(styles);
  const [uploadComplete, setUploadComplete] = useState(false)
  const [hasHeaders, setHasHeaders] = useState(true)
  const [fein, setFein] = useState('')
  const [singleScrubberHasError, setSingleScrubberHasError] = useState(false)
  const [singleScrubberErrorMessage, setSingleScrubberErrorMessage] = useState(null)
  
  const handleDialogClose = () => {
    setUploadComplete(false)
    onCloseDialog()
  };

  const handleChooseContinue = () => {
    handleDialogClose()
    history.push(`/merchant_scrubber_imports`)
  };

  const handleFileUploadComplete = () => {
    setUploadComplete(true)
  };

  const toggleHeaders = () => {
    setHasHeaders(!hasHeaders)
  };

  const onAddSingleMerchantScrubberClick = (event) => {
    event.preventDefault();

    if (fein.length != 10){
      setSingleScrubberErrorMessage("EIN must be 11 characters")
      setSingleScrubberHasError(true)
    } else {
      onAddSingleMerchantScrubber(fein, accountId, page, per_page, search)
    }
  }

  useEffect(() => {
   setFein('')
   setSingleScrubberErrorMessage(null)
   setSingleScrubberHasError(false)
  }, [openDialog])

  return (
    <Dialog
      open={openDialog}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          '& h2': {
            fontSize: '20px',
            lineHeight: '30px',
          }
        }}
      >
        {"Merchant Scrubber"}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{
            '& span': {
              fontSize: '16px',
              lineHeight: '20px',
              color: '#000'
            },
            '& p': {
              fontSize: '16px',
              lineHeight: '20px',
              color: '#000'
            }
          }} 
          component="div">
          <p><b>Upload file to be scrubbed</b></p>
          <span>Upload a CSV file containing the merchants you would like to scrub against DataMerch. <br></br><br></br> <b>IMPORTANT: The FIRST column in the CSV MUST contain the merchant's EIN.</b></span>
          <br></br>
          <br></br>
          <FormControlLabel control={<Checkbox checked={hasHeaders} onClick={toggleHeaders} />} label="CSV has header row" />
          <UploadFile 
            accountId={accountId}
            uploadType="merchant_scrubbers"
            onUploadComplete={() => handleFileUploadComplete()}
            accept=".csv"
            importType="scrubber"
            headers={hasHeaders}
          />
          {uploadComplete && 
            <Typography variant="subtitle2" className={`upload-message`}>
              <p className={classes.upload_processed_text}>Your file has been uploaded and will now be processed!</p><br></br><p>You will be notified by email when your list has been scrubbed.</p><br></br><p>The results of the scrub will be available on this page.</p>
            </Typography>
          }
          <br></br>
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        {!uploadComplete &&
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
        }
        {uploadComplete &&
          <Button
            onClick={handleChooseContinue}
            variant="contained"
            color="primary"
            autoFocus
          >
            Ok
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => {
  return {
    openDialog: state.merchantScrubberImport.merchant_scrubber_dialog_open
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCloseDialog: () => dispatch(actions.closeMerchantScrubberDialog()),
    // onAddSingleMerchantScrubber: (fein, account_id, page, per_page, search) => dispatch(actions.addMerchantScrubber(fein, account_id, page, per_page, search))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MerchantScrubberDialog)
